import { Illustration, Text, Title } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

export interface TouchpointSkipWarningProps {
  facilityName: string;
  clockAction: "clock-in" | "clock-out";
  onCancel: () => void;
  onContinue: () => void;
}

export function TouchpointSkipWarning(props: TouchpointSkipWarningProps) {
  const { facilityName, clockAction, onCancel, onContinue } = props;

  return (
    <>
      <DialogContent sx={{ paddingX: 6, paddingTop: 8, textAlign: "center" }}>
        <Stack spacing={4} alignItems="center">
          <Title semibold variant="h3" component="h3">
            Possible penalties
          </Title>
          <Illustration type="warning" />
          <Text semibold>{facilityName} requires professionals to clock in/out at the kiosk. </Text>
          <Text semibold sx={{ color: (theme) => theme.palette.error.main }}>
            Failure to do so may result in penalties like DNR or payment reversals.
          </Text>
          <Text semibold>
            Proceed with clock {clockAction === "clock-in" ? "in" : "out"} only if you are certain
            that the kiosk is not working.
          </Text>
        </Stack>
      </DialogContent>
      <DialogFooter orientation="vertical" closeButtonAriaLabel="Go back">
        <Button fullWidth variant="contained" size="large" onClick={onCancel}>
          Scan QR code
        </Button>
        <Button fullWidth variant="outlined" size="large" onClick={onContinue}>
          Continue with clock {clockAction === "clock-in" ? "in" : "out"}
        </Button>
      </DialogFooter>
    </>
  );
}
